var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shareInNetwork"},[_c('div',{staticClass:"prdt_hdng"},[_vm._v(_vm._s(_vm.$t('shareAndEarnInNetwork')))]),_c('h5',{staticClass:"head"},[_vm._v(_vm._s(_vm.$t('shareAndEarnfivePerson')))])])}
var staticRenderFns = []

export { render, staticRenderFns }